import React from 'react';
import styled, { keyframes } from 'styled-components';
import { BusinessButton } from '../BusinessButton/BusinessButton';

// Battery charging animation
const charge = keyframes`
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
`;

const BatteryIcon = styled.div`
  position: relative;
  width: 24px;
  height: 12px;
  border: 2px solid currentColor;
  border-radius: 2px;
  margin-right: 8px;
  
  &::before {
    content: '';
    position: absolute;
    right: -6px;
    top: 2px;
    width: 4px;
    height: 4px;
    background: currentColor;
    border-radius: 0 2px 2px 0;
  }
`;

const BatteryFill = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: currentColor;
  border-radius: 1px;
  animation: ${charge} 2s ease-in-out infinite;
  opacity: 0.8;
`;

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${pulse} 2s ease-in-out infinite;
`;

interface CreatingButtonProps {
  text?: string;
  businessSize?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

export const CreatingButton: React.FC<CreatingButtonProps> = ({ 
  text = 'Creating...', 
  businessSize = 'large',
  disabled = true 
}) => {
  return (
    <BusinessButton
      variant="primary"
      businessSize={businessSize}
      disabled={disabled}
    >
      <ButtonContent>
        <BatteryIcon>
          <BatteryFill />
        </BatteryIcon>
        {text}
      </ButtonContent>
    </BusinessButton>
  );
};
